import PropTypes from 'prop-types';
import { get } from 'lodash';
import React, { PureComponent } from 'react';
import { Tabs, Tab } from 'react-bootstrap/lib';
import PricingButtonGroupEditor from './editors/PricingButtonGroupEditor';
import StandaloneButtonsEditor from './editors/StandaloneButtonsEditor';
import APIEditor from './editors/APIEditor';
import './WidgetConfigEditor.scss';

const WIDGET_EDITOR_TAB_LIST = [
  {
    name: 'Vehicle Detail',
    title: 'Vehicle Detail Pricing Button Group',
    type: 'VDP',
    editor: PricingButtonGroupEditor,
  },
  {
    name: 'Search Results',
    title: 'Search Results Pricing Button Group',
    type: 'SRP',
    editor: PricingButtonGroupEditor,
  },
  {
    name: 'Standalone Buttons',
    title: 'Standalone Buttons',
    type: 'STANDALONE',
    editor: StandaloneButtonsEditor,
  },
  {
    name: 'Widget API',
    title: 'Widget API',
    type: 'API',
    editor: APIEditor,
  },
];

class WidgetConfigEditor extends PureComponent {
  onSave = (page) => {
    const { widgetConfig, onPageSave, onStandaloneSave } = this.props;
    if (page.type === 'STANDALONE') {
      onStandaloneSave(widgetConfig);
    } else {
      onPageSave(widgetConfig, { activeTab: page.type });
    }
  };

  renderTab = (page) => {
    const { dealer, widgetConfig, setActiveTab, onChange } = this.props;
    const { name, type, editor: Editor } = page;
    const config = get(widgetConfig, 'config');
    if (!config) {
      return null;
    }
    const formData = get(config, `${type}`) || {};
    const onFormDataChange = (newFormData) =>
      onChange({ ...widgetConfig, config: { ...config, [type]: newFormData } });
    return (
      <Tab
        key={type}
        eventKey={type}
        title={name}
        onClick={() => setActiveTab(page)}
      >
        <Editor
          dealer={dealer}
          page={page}
          formData={formData}
          onChange={onFormDataChange}
          onSave={() => this.onSave(page)}
        />
      </Tab>
    );
  };

  render() {
    return (
      <div className="widget-config-editor">
        {this.props.fetching && <div className="widget-loader" />}
        <Tabs id="widget-config-tabs">
          {WIDGET_EDITOR_TAB_LIST.map(this.renderTab)}
        </Tabs>
      </div>
    );
  }
}

WidgetConfigEditor.propTypes = {
  dealer: PropTypes.object,
  fetching: PropTypes.bool,
  widgetConfig: PropTypes.object,
  onChange: PropTypes.func,
  onPageSave: PropTypes.func,
  onStandaloneSave: PropTypes.func,
  setActiveTab: PropTypes.func,
};

export default WidgetConfigEditor;
